<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/9HAT/9HAT.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">9HAT 纵置9速混动液力自动变速器</div>
                <div class="detail-banner-desc transmission">
                    
                    <div class="detail-desc">
                        <div>
                            集成高性能P2电机，峰值性能130kW/495N·m；<br />
                        </div>
                        <div>
                            可实现整车纯油、纯电、混动、发电等多种工作模式；<br />
                        </div>
                        <div>
                            电机与液力变矩器一体化设计，实现强悍的动力性能。
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/9HAT/9HAT-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">850N·m</div>
                                    <div class="k">扭矩容量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">9+R</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">720.8mm</div>
                                    <div class="k">轴向尺寸</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">129kg</div>
                                    <div class="k">重量（含油）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8.843</div>
                                    <div class="k">速比范围</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">电液控制系统</div>
                                    <div class="k">执行系统</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">130kW/495N·m</div>
                                    <div class="k">P2电机峰值性能</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '9HAT 纵置9速混动液力自动变速器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/9HAT.html'
};

import { createApp } from 'vue';
import App from './9HAT.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./9HAT.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
